.panel {
    width: 550px;
}

.body {
    padding-inline: 0;
}

.empty {
    composes: safeContainer from "../../../styles/composable/layout.module.css";
    font: var(--font-p-18);
    text-wrap: pretty;
}

.footer {
    flex: 0 0 auto;
    border-top: 1px solid var(--gray-300);
}
